import './style.scss';

export default function BodyContainer({ children }) {
  return <div className="container">{children}</div>;
}
